import React, { useEffect } from 'react';
import { mergeProps } from 'next-merge-props';
import { useRouter } from 'next/router';
import getConfig from 'next/config';

import { getServerSideSessionProps } from '../../../../modules/classrooms/getServerSideSessionProps';

import { useAuthContext } from '../../../../context/Auth';

import { FullPageLoader } from '../../../../components/Loader/FullPageLoader';

const { serverRuntimeConfig, publicRuntimeConfig } = getConfig();
const { cognitoDomain, cognitoClientId } = serverRuntimeConfig;
const { domain } = publicRuntimeConfig;

interface RegisterPage {
  registerRedirect: string;
}

export default function Register({ registerRedirect }: RegisterPage) {
  const { isAuthenticated } = useAuthContext();
  const router = useRouter();

  useEffect(() => {
    setTimeout(() => {
      if (isAuthenticated) {
        router.push('/classrooms/lesson-library');
      } else {
        router.push(registerRedirect);
      }
    }, 500);
  }, [isAuthenticated]);

  return <FullPageLoader />;
}

const getServerSideRedirectProps = async () => {
  const redirectUri = `${domain}/classrooms/lesson-library/u/login`;
  const registerRedirect = `${cognitoDomain}/signup?client_id=${cognitoClientId}&redirect_uri=${redirectUri}&response_type=code`;

  return {
    props: { registerRedirect }
  };
};

export const getServerSideProps = mergeProps([
  getServerSideSessionProps,
  getServerSideRedirectProps
]);
